import { FC } from 'react';
import { Styled, SwitchProps } from './';
import { LoadingSpinner } from '../../../styles/sharedStyles';

const Switch: FC<SwitchProps> = ({
  checked = false,
  disabled = false,
  loading = false,
  onChange,
  label,
  width,
}) => {
  return (
    <Styled.SwitchContainer width={width}>
      {label && <Styled.Label>{label}</Styled.Label>}
      <Styled.SwitchWrapper>
        {loading ? <LoadingSpinner /> : null}
        <Styled.SwitchButtonContainer
          onClick={() => {
            if (!disabled) {
              onChange();
            }
          }}
          checked={checked}
          disabled={disabled}
          loading={loading}
        >
          <Styled.ToggleButton
            checked={checked}
            disabled={disabled}
            loading={loading}
          ></Styled.ToggleButton>
        </Styled.SwitchButtonContainer>
      </Styled.SwitchWrapper>
    </Styled.SwitchContainer>
  );
};

export default Switch;
